import { render, staticRenderFns } from "./article.vue?vue&type=template&id=41fc26ed&scoped=true"
import script from "./article.vue?vue&type=script&lang=js"
export * from "./article.vue?vue&type=script&lang=js"
import style0 from "./article.vue?vue&type=style&index=0&id=41fc26ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fc26ed",
  null
  
)

export default component.exports